export const environment = {
  apiUrl: 'https://api3.doc2txt.com',
  // apiUrl: 'https://ocr.doc2txt.com',

  // apiUrl: 'https://doc2txt.p.rapidapi.com',

  ocrPlusUrl: 'https://api3.doc2txt.com',


  gptStreamUrl: 'https://bxuljeza5l5wp7hfjoj5vszdqu0wvptn.lambda-url.eu-west-3.on.aws/',

  token: '96a320e1-2305-4b28-92a0-8246feee31df',
  companyID: '191238625',
  billingLinks: [
    {
      url: 'https://pay.sumit.co.il/35uwo1/35uyo6/39130z/payment/',
      text: 'תשלום חודשי עבור מנוי',
    },
  ],

  topUpLinks: [
    {
      url: 'https://pay.sumit.co.il/35uwo1/35uyo6/37dx2y/payment/',
      text: '10 טוקנים ב <b>10</b> שח',
    },
    {
      url: 'https://pay.sumit.co.il/35uwo1/35uyo6/37e4yi/payment/',
      text: '200 טוקנים ב <b>200</b> שח',
    },
    {
      url: 'https://pay.sumit.co.il/35uwo1/35uyo6/37e4yq/payment/',
      text: '1000 טוקנים ב <b>800</b> שח',
    },
    {
      url: 'https://pay.sumit.co.il/35uwo1/35uyo6/37e4z8/payment/',
      text: '5000 טוקנים ב <b>3000</b> שח',
    },
    {
      url: 'https://pay.sumit.co.il/35uwo1/35uyo6/37e4zl/payment/',
      text: '10000 טוקנים ב <b>5000</b> שח',
    },
    {
      url: 'https://pay.sumit.co.il/35uwo1/35uyo6/37e563/payment/',
      text: '20000 טוקנים ב <b>8000</b> שח',
    },
  ],
};
